export default __webpack_public_path__ + "static/media/11.0100729f.jpg";